

/**
 * GetInspecaoPatrimonioByIdUseCase
 */

import { IGetInspecaoPatrimonioByIdUseCase } from "../../../presentation/useCases/read/get_inspecao_patrimonio_by_id_use_case";
import { InspecaoPatrimonioModel } from "../../models/inspecao_patrimonio";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class GetInspecaoPatrimonioByIdUseCase implements IGetInspecaoPatrimonioByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getInspecaoPatrimonioById(
    idInspecaoPatrimonio: number,
  ): Promise<InspecaoPatrimonioModel> {
    return await this.repository.getInspecaoPatrimonioById(idInspecaoPatrimonio);
  }
}
